import MarketPersonalInfoComponent from './MarketPersonalInfoContainer';

export default MarketPersonalInfoComponent;
